import { NotificationUtils } from "./index";
export var showErrorModal = function (message, title, onOk) {
    if (message === void 0) { message = "Sorry for the inconvenience."; }
    if (title === void 0) { title = "Functionality currently unavailable."; }
    return NotificationUtils.error(title, message, "ghost", undefined, undefined, 4);
};
//# sourceMappingURL=error.js.map